import { createContext, Dispatch } from "react";
import { ChatbotAction, ChatbotState, initialChatBotState } from "./chatbotStateReducer";

export const ChatbotStateContext = createContext<ChatbotState>(initialChatBotState);
const noopDispatch: Dispatch<ChatbotAction> = () => {
  // No-op dispatch function
};
export const ChatbotStateDispatchContext = createContext<Dispatch<ChatbotAction>>(noopDispatch);
